import { render, staticRenderFns } from "./footerItem.vue?vue&type=template&id=04d41abb&scoped=true&"
import script from "./footerItem.vue?vue&type=script&lang=js&"
export * from "./footerItem.vue?vue&type=script&lang=js&"
import style0 from "./footerItem.vue?vue&type=style&index=0&id=04d41abb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d41abb",
  null
  
)

component.options.__file = "footerItem.vue"
export default component.exports